import React from 'react';
import { Link } from 'react-router-dom';

export default class AboutTwo extends React.Component {
    render(){
        let publicUrl = process.env.PUBLIC_URL+'/'
        return (
            <>
                <section className="about-one about-one--two">
                    <div className="shape4"><img src={publicUrl+"assets/images/shapes/about-v1-shape4.png"} alt="#" /></div>
                    <div className="container">
                        <div className="row">
                            {/* Start About One Left */}
                            <div className="col-xl-6">
                                <div className="about-one__left">
                                    <div className="about-one__left-img">
                                        <div className="shape1 float-bob-y"></div>
                                        <div className="shape2 float-bob-y"></div>
                                        <div className="shape3 float-bob-y"></div>
                                        <img src={publicUrl+"assets/images/about/technical.png"} alt="#" />
                                    </div>
                                </div>
                            </div>
                            {/* End About One Left */}

                            {/* Start About One Right */}
                            <div className="col-xl-6">
                                <div className="about-one__right">
                                    <div className="about-one__right-title">
                                        <h2>Why We”ar Best About.</h2>
                                    </div>

                                    <div className="about-one__right-text1">
                      
                                    </div>
                                    <div className="about-one__right-text2">
                                        <p>We are a forward-thinking company dedicated to delivering reliable, innovative, and results-driven solutions for businesses of all sizes. Our focus is on combining technology, strategy, and creativity to help organizations grow, streamline operations, and achieve long-term success. With a commitment to quality, transparency, and customer satisfaction, we work closely with our clients to understand their goals and turn ideas into impactful outcomes.</p>
                                    </div>
                                    <div className="about-one__right-text3">
                                        <div className="about-one__right-text3-icon" style={{backgroundImage: 'url('+publicUrl+'assets/images/shapes/about-v1-shape5.png)'}}>
                                            <span className="icon-budget"></span>
                                        </div>
                                        <div className="about-one__right-text3-content">
                                            <h2>Budget Planing Business.</h2>
                                            <p>Strategic budget planning solutions designed to improve financial control and business performance. </p>
                                        </div>
                                    </div>
                                    <div className="about-one__right-text4">
                                        <p>Our approach combines strategic insight, industry expertise, and innovative thinking to deliver dependable solutions that support long-term business success.
                                            If you want it finance-specific, IT-focused, or marketing-oriented, I can customize it instantly. 
                                        </p>
                                    </div>
                                    <div className="about-one__right-btn">
                                        <Link to={process.env.PUBLIC_URL + `/`} className="thm-btn">About More</Link>
                                    </div>
                                </div>
                            </div>
                            {/* End About One Right */}
                        </div>
                    </div>
                </section>
            </>
        )
    }
}